// Textos dos Prazos de saúde e segurança do DP (04/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.prazosSst.titulo': 'Prazos de saúde e segurança',
    'dp.prazosSst.ajuda': 'Junta os prazos das três telas de Saúde e segurança: o prazo máximo da convocação de exame ocupacional, o próximo toxicológico periódico e o vencimento da CNH. Cada prazo segue a regra e o aviso do próprio módulo, nos Parâmetros. Esta tela só lê: para registrar, agendar ou anexar, abra o prazo e siga para a tela de origem, que já vem filtrada na pessoa. Quem está isento do toxicológico pela idade e a convocação cancelada ficam fora.',
    'dp.prazosSst.visao': 'Visualização',
    'dp.prazosSst.visao.relatorio': 'Relatório',
    'dp.prazosSst.visao.calendario': 'Calendário',
    'dp.prazosSst.visao.linha': 'Linha do tempo',
    'dp.prazosSst.visao.quadro': 'Quadro por filial',
    'dp.prazosSst.kpi.vencidos': 'Vencidos',
    'dp.prazosSst.kpi.aVencer': 'A vencer',
    'dp.prazosSst.kpi.aVencerDica': 'No aviso de cada módulo: exame em {{exame}} dias, toxicológico em {{toxicologico}} e CNH em {{cnh}}',
    'dp.prazosSst.kpi.escalados': 'Escalados vencidos',
    'dp.prazosSst.kpi.semData': 'Sem data',
    'dp.prazosSst.kpi.semDataDica': 'CNH sem vencimento, toxicológico sem exame registrado ou convocação sem prazo máximo',
    'dp.prazosSst.kpi.tipoDica': 'Vencidos e a vencer deste tipo',
    'dp.prazosSst.kpi.tipo.exame': 'Exames',
    'dp.prazosSst.kpi.tipo.toxicologico': 'Toxicológico',
    'dp.prazosSst.kpi.tipo.cnh': 'CNH',
    'dp.prazosSst.tipo': 'Tipo',
    'dp.prazosSst.tipo.todos': 'Todos os tipos',
    'dp.prazosSst.tipo.exame': 'Exame ocupacional',
    'dp.prazosSst.tipo.toxicologico': 'Toxicológico',
    'dp.prazosSst.tipo.cnh': 'CNH',
    'dp.prazosSst.situacao.todas': 'Todas',
    'dp.prazosSst.situacao.vencido': 'Vencido',
    'dp.prazosSst.situacao.a_vencer': 'A vencer',
    'dp.prazosSst.situacao.em_dia': 'Em dia',
    'dp.prazosSst.situacao.sem_data': 'Sem data',
    'dp.prazosSst.situacao.concluido': 'Feito',
    'dp.prazosSst.maisFiltros': 'Mais filtros',
    'dp.prazosSst.venceDe': 'Vence de',
    'dp.prazosSst.venceAte': 'Vence até',
    'dp.prazosSst.vencimento': 'Vencimento',
    'dp.prazosSst.venceEm': 'Vence em {{dia}}',
    'dp.prazosSst.prazo': 'Prazo',
    'dp.prazosSst.situacaoNoModulo': 'Situação no módulo',
    'dp.prazosSst.abrir': 'Abrir',
    'dp.prazosSst.abrirEm.exame': 'Abrir em Exames',
    'dp.prazosSst.abrirEm.toxicologico': 'Abrir em Toxicológico',
    'dp.prazosSst.abrirEm.cnh': 'Abrir em CNH',
    'dp.prazosSst.matricula': 'Matrícula',
    'dp.prazosSst.funcao': 'Função',
    'dp.prazosSst.mesDaConvocacao': 'Mês da convocação',
    'dp.prazosSst.agendadoPara': 'Agendado para',
    'dp.prazosSst.examesARealizar': 'Exames a realizar',
    'dp.prazosSst.ultimaColeta': 'Última coleta',
    'dp.prazosSst.admissaoValidaAte': 'Exame de admissão vale até',
    'dp.prazosSst.categoriaCnh': 'Categoria da CNH',
    'dp.prazosSst.escaladoEm': 'Escalado em',
    'dp.prazosSst.escaladoEmDia': 'Escalado {{dia}}',
    'dp.prazosSst.escaladoVencido': 'Escalado com o prazo vencido',
    'dp.prazosSst.escaladoVencidoDetalhe': 'Está escalado hoje ou amanhã com o prazo vencido.',
    'dp.prazosSst.doDia': 'Prazos de {{dia}}',
    'dp.prazosSst.semNoPeriodo': 'Nenhum prazo vence neste período.',
    'dp.prazosSst.teto': 'Este período tem {{total}} prazos e a tela mostra até {{teto}}. Filtre para ver todos.',
    'dp.prazosSst.quadro.vencidos': '{{n}} vencidos',
    'dp.prazosSst.quadro.vencidosUm': '1 vencido',
    'dp.prazosSst.quadro.aVencer': '{{n}} a vencer',
    'dp.prazosSst.quadro.emDia': '{{n}} em dia',
    'dp.prazosSst.quadro.semData': '{{n}} sem data',
    'dp.prazosSst.quadro.nada': 'Nenhum prazo',
    'dp.prazosSst.quadro.total': 'Total',
    'dp.prazosSst.quadroVazio': 'Nenhum prazo nas filiais do filtro.',
  },
  en: {
    'dp.prazosSst.titulo': 'Health and safety deadlines',
    'dp.prazosSst.ajuda': 'Brings together the deadlines of the three Health and safety screens: the deadline of the occupational exam call, the next periodic drug test and the driver\'s license expiry. Each deadline follows its own module\'s rule and warning, in Parameters. This screen is read only: to record, schedule or attach, open the deadline and go to the source screen, already filtered on the person. People exempt from the drug test by age and cancelled calls are left out.',
    'dp.prazosSst.visao': 'View',
    'dp.prazosSst.visao.relatorio': 'Report',
    'dp.prazosSst.visao.calendario': 'Calendar',
    'dp.prazosSst.visao.linha': 'Timeline',
    'dp.prazosSst.visao.quadro': 'Board by branch',
    'dp.prazosSst.kpi.vencidos': 'Overdue',
    'dp.prazosSst.kpi.aVencer': 'Due soon',
    'dp.prazosSst.kpi.aVencerDica': 'Within each module\'s warning: exam in {{exame}} days, drug test in {{toxicologico}} and license in {{cnh}}',
    'dp.prazosSst.kpi.escalados': 'Scheduled overdue',
    'dp.prazosSst.kpi.semData': 'No date',
    'dp.prazosSst.kpi.semDataDica': 'License without expiry, drug test without a recorded exam or exam call without a deadline',
    'dp.prazosSst.kpi.tipoDica': 'Overdue and due soon of this type',
    'dp.prazosSst.kpi.tipo.exame': 'Exams',
    'dp.prazosSst.kpi.tipo.toxicologico': 'Drug test',
    'dp.prazosSst.kpi.tipo.cnh': 'License',
    'dp.prazosSst.tipo': 'Type',
    'dp.prazosSst.tipo.todos': 'All types',
    'dp.prazosSst.tipo.exame': 'Occupational exam',
    'dp.prazosSst.tipo.toxicologico': 'Drug test',
    'dp.prazosSst.tipo.cnh': 'Driver\'s license',
    'dp.prazosSst.situacao.todas': 'All',
    'dp.prazosSst.situacao.vencido': 'Overdue',
    'dp.prazosSst.situacao.a_vencer': 'Due soon',
    'dp.prazosSst.situacao.em_dia': 'Up to date',
    'dp.prazosSst.situacao.sem_data': 'No date',
    'dp.prazosSst.situacao.concluido': 'Done',
    'dp.prazosSst.maisFiltros': 'More filters',
    'dp.prazosSst.venceDe': 'Due from',
    'dp.prazosSst.venceAte': 'Due until',
    'dp.prazosSst.vencimento': 'Due date',
    'dp.prazosSst.venceEm': 'Due on {{dia}}',
    'dp.prazosSst.prazo': 'Deadline',
    'dp.prazosSst.situacaoNoModulo': 'Status in the module',
    'dp.prazosSst.abrir': 'Open',
    'dp.prazosSst.abrirEm.exame': 'Open in Exams',
    'dp.prazosSst.abrirEm.toxicologico': 'Open in Drug test',
    'dp.prazosSst.abrirEm.cnh': 'Open in License',
    'dp.prazosSst.matricula': 'Employee ID',
    'dp.prazosSst.funcao': 'Role',
    'dp.prazosSst.mesDaConvocacao': 'Call month',
    'dp.prazosSst.agendadoPara': 'Scheduled for',
    'dp.prazosSst.examesARealizar': 'Exams to take',
    'dp.prazosSst.ultimaColeta': 'Last collection',
    'dp.prazosSst.admissaoValidaAte': 'Admission test valid until',
    'dp.prazosSst.categoriaCnh': 'License category',
    'dp.prazosSst.escaladoEm': 'Scheduled on',
    'dp.prazosSst.escaladoEmDia': 'Scheduled {{dia}}',
    'dp.prazosSst.escaladoVencido': 'Scheduled with the deadline overdue',
    'dp.prazosSst.escaladoVencidoDetalhe': 'Scheduled today or tomorrow with the deadline overdue.',
    'dp.prazosSst.doDia': 'Deadlines on {{dia}}',
    'dp.prazosSst.semNoPeriodo': 'No deadline falls in this period.',
    'dp.prazosSst.teto': 'This period has {{total}} deadlines and the screen shows up to {{teto}}. Filter to see them all.',
    'dp.prazosSst.quadro.vencidos': '{{n}} overdue',
    'dp.prazosSst.quadro.vencidosUm': '1 overdue',
    'dp.prazosSst.quadro.aVencer': '{{n}} due soon',
    'dp.prazosSst.quadro.emDia': '{{n}} up to date',
    'dp.prazosSst.quadro.semData': '{{n}} no date',
    'dp.prazosSst.quadro.nada': 'No deadline',
    'dp.prazosSst.quadro.total': 'Total',
    'dp.prazosSst.quadroVazio': 'No deadline in the filtered branches.',
  },
  es: {
    'dp.prazosSst.titulo': 'Plazos de salud y seguridad',
    'dp.prazosSst.ajuda': 'Reúne los plazos de las tres pantallas de Salud y seguridad: el plazo máximo de la convocatoria de examen ocupacional, el próximo toxicológico periódico y el vencimiento de la licencia. Cada plazo sigue la regla y el aviso de su módulo, en Parámetros. Esta pantalla solo lee: para registrar, agendar o adjuntar, abra el plazo y siga a la pantalla de origen, ya filtrada en la persona. Quien está exento del toxicológico por la edad y la convocatoria cancelada quedan fuera.',
    'dp.prazosSst.visao': 'Visualización',
    'dp.prazosSst.visao.relatorio': 'Informe',
    'dp.prazosSst.visao.calendario': 'Calendario',
    'dp.prazosSst.visao.linha': 'Línea de tiempo',
    'dp.prazosSst.visao.quadro': 'Cuadro por sucursal',
    'dp.prazosSst.kpi.vencidos': 'Vencidos',
    'dp.prazosSst.kpi.aVencer': 'Por vencer',
    'dp.prazosSst.kpi.aVencerDica': 'En el aviso de cada módulo: examen en {{exame}} días, toxicológico en {{toxicologico}} y licencia en {{cnh}}',
    'dp.prazosSst.kpi.escalados': 'Escalados vencidos',
    'dp.prazosSst.kpi.semData': 'Sin fecha',
    'dp.prazosSst.kpi.semDataDica': 'Licencia sin vencimiento, toxicológico sin examen registrado o convocatoria sin plazo máximo',
    'dp.prazosSst.kpi.tipoDica': 'Vencidos y por vencer de este tipo',
    'dp.prazosSst.kpi.tipo.exame': 'Exámenes',
    'dp.prazosSst.kpi.tipo.toxicologico': 'Toxicológico',
    'dp.prazosSst.kpi.tipo.cnh': 'Licencia',
    'dp.prazosSst.tipo': 'Tipo',
    'dp.prazosSst.tipo.todos': 'Todos los tipos',
    'dp.prazosSst.tipo.exame': 'Examen ocupacional',
    'dp.prazosSst.tipo.toxicologico': 'Toxicológico',
    'dp.prazosSst.tipo.cnh': 'Licencia de conducir',
    'dp.prazosSst.situacao.todas': 'Todas',
    'dp.prazosSst.situacao.vencido': 'Vencido',
    'dp.prazosSst.situacao.a_vencer': 'Por vencer',
    'dp.prazosSst.situacao.em_dia': 'Al día',
    'dp.prazosSst.situacao.sem_data': 'Sin fecha',
    'dp.prazosSst.situacao.concluido': 'Hecho',
    'dp.prazosSst.maisFiltros': 'Más filtros',
    'dp.prazosSst.venceDe': 'Vence desde',
    'dp.prazosSst.venceAte': 'Vence hasta',
    'dp.prazosSst.vencimento': 'Vencimiento',
    'dp.prazosSst.venceEm': 'Vence el {{dia}}',
    'dp.prazosSst.prazo': 'Plazo',
    'dp.prazosSst.situacaoNoModulo': 'Situación en el módulo',
    'dp.prazosSst.abrir': 'Abrir',
    'dp.prazosSst.abrirEm.exame': 'Abrir en Exámenes',
    'dp.prazosSst.abrirEm.toxicologico': 'Abrir en Toxicológico',
    'dp.prazosSst.abrirEm.cnh': 'Abrir en Licencia',
    'dp.prazosSst.matricula': 'Matrícula',
    'dp.prazosSst.funcao': 'Función',
    'dp.prazosSst.mesDaConvocacao': 'Mes de la convocatoria',
    'dp.prazosSst.agendadoPara': 'Agendado para',
    'dp.prazosSst.examesARealizar': 'Exámenes a realizar',
    'dp.prazosSst.ultimaColeta': 'Última recolección',
    'dp.prazosSst.admissaoValidaAte': 'Examen de admisión vale hasta',
    'dp.prazosSst.categoriaCnh': 'Categoría de la licencia',
    'dp.prazosSst.escaladoEm': 'Escalado el',
    'dp.prazosSst.escaladoEmDia': 'Escalado {{dia}}',
    'dp.prazosSst.escaladoVencido': 'Escalado con el plazo vencido',
    'dp.prazosSst.escaladoVencidoDetalhe': 'Está escalado hoy o mañana con el plazo vencido.',
    'dp.prazosSst.doDia': 'Plazos del {{dia}}',
    'dp.prazosSst.semNoPeriodo': 'Ningún plazo vence en este período.',
    'dp.prazosSst.teto': 'Este período tiene {{total}} plazos y la pantalla muestra hasta {{teto}}. Filtre para ver todos.',
    'dp.prazosSst.quadro.vencidos': '{{n}} vencidos',
    'dp.prazosSst.quadro.vencidosUm': '1 vencido',
    'dp.prazosSst.quadro.aVencer': '{{n}} por vencer',
    'dp.prazosSst.quadro.emDia': '{{n}} al día',
    'dp.prazosSst.quadro.semData': '{{n}} sin fecha',
    'dp.prazosSst.quadro.nada': 'Ningún plazo',
    'dp.prazosSst.quadro.total': 'Total',
    'dp.prazosSst.quadroVazio': 'Ningún plazo en las sucursales del filtro.',
  },
}
